window.M = window.M || {};
window.M.Modal = function(options) {
	var self = this;
	
	this.template = options.template;
	this.buttons = options.buttons;
	this.title = options.title;
	this.onshow = options.onshow;
	this.onComplete = options.onhide;
	this.onButton = options.onButton || (function(){});
	
	if(options.size == "large") {
		this.size = "modal-lg";
	} else if(options.size == "small") {
		this.size = "modal-sm";
	} else {
		this.size = "";
	}
	
	this.lightbox = $.parseHTML(M.templates.modal({
        buttons: this.buttons,
		size: this.size
    }));
	
	
	
	$(document.body).append(this.lightbox);
	
	$(this.lightbox).modal({
        show:false
    });
	$(this.lightbox).on('hide.bs.modal', function() {
        if(self.onComplete) self.onComplete();
    });
    $(this.lightbox).on('shown.bs.modal', function() {
        if(self.onshow) self.onshow.call(self, self.canv, self.data);
    });
	
	$(".modal-footer", this.lightbox).delegate("button", "click", function() {
        if($(this).data("id") == "cancel" || $(this).data("id") == "close") {
            self.close();
			return;
        }
		
		self.onButton.call(self, $(this).data("id"));
    });
	
};

window.M.Modal.prototype = {
	show: function(data, onComplete) {
		var self = this;
		
		self.data = data;
		
		if(onComplete) {
			self.onComplete = onComplete;
		}
		
		$(self.lightbox).modal('show');
		
		self.canv = $(".modal-body", self.lightbox);
		
		$(".modal-title", self.lightbox).html(self.title);
		
		self.canv.html(self.template(self.data));
		
	},
	
	close: function() {
        $(this.lightbox).modal('hide');
    }
};